import { Grid } from '@mui/material';
import { ChartBox, SlideParagraph, SlideTitle } from 'features/slides';
import { PortfolioStatisticsLineChart } from 'pages/Cases/components/PortfolioStatisticsLineChart';
import { portfolioStatisticsChartFilter } from 'pages/Cases/PortfolioConstruction/Summary/PerformanceReport';
import React from 'react';

export type RollingOneYearReturnAndExcessReturnProps = {
  readonly filteredPerformance: any;
};

export function RollingOneYearReturnAndExcessReturn({
  filteredPerformance,
}: RollingOneYearReturnAndExcessReturnProps): React.ReactElement {
  return (
    <Grid
      container
      flexDirection="column"
      gap={0}
      sx={{
        width: '100%',
        padding: '10px',
      }}
    >
      <Grid
        container
        sx={{
          marginBottom: '6px',
        }}
      >
        <SlideTitle>Rolling 1-Year Return and Excess Return</SlideTitle>
      </Grid>

      <ChartBox>
        <PortfolioStatisticsLineChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'rolling_one_year_stats',
            subName: '1_year_rolling_returns',
          })}
          formatChart={{
            unit: '%',
            decimals: 2,
            prefix: '',
            value: 'Return',
            label: 'Return (%)',
          }}
          height={250}
          isWithAnimation={false}
          showLegend={false}
        />
      </ChartBox>

      <ChartBox>
        <PortfolioStatisticsLineChart
          data={portfolioStatisticsChartFilter({
            filteredPerformance,
            name: 'rolling_one_year_stats',
            subName: '1_year_excess_returns',
          })}
          formatChart={{
            unit: '%',
            decimals: 2,
            prefix: '',
            value: 'Excess Return',
            label: 'Excess Return (%)',
          }}
          height={250}
          isWithAnimation={false}
        />
      </ChartBox>
      <SlideParagraph
        style={{
          marginBottom: '10px',
          marginTop: '10px',
          fontSize: '13px',
        }}
      >
        Source: TIFIN Sage
      </SlideParagraph>
    </Grid>
  );
}
